import * as React from 'react';
export const ILSvg = React.forwardRef(function ILSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M1.505 2h12.99C15.333 2 16 2.672 16 3.5V5H0V3.5A1.5 1.5 0 0 1 1.505 2ZM0 11h16v1.5a1.5 1.5 0 0 1-1.505 1.5H1.505A1.498 1.498 0 0 1 0 12.5V11Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M0 5h16v6H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 11V5h1v6h-1ZM0 5h1v6H0V5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'm8.929 7.986-.643-.857h-.572l-.643.857.643.857h.572l.643-.857Zm.428 0 .643.857H8.857L8 10.27l-.857-1.428H6l.643-.857L6 7.129h1.143L8 5.7l.857 1.429H10l-.643.857Z',
      }),
    ),
  );
});
ILSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var IL = {
  category: 'flag',
  colorable: false,
  name: 'IL',
  svg: ILSvg,
};
